import script from "./ContentEditable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentEditable.vue?vue&type=script&lang=ts&setup=true"

import "./ContentEditable.vue?vue&type=style&index=0&id=5041e3da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5041e3da"]])

export default __exports__